module.exports = __webpack_public_path__ + "img/gh-30513-3.prt.36b92fce.jpg";